import { render, staticRenderFns } from "./nodata.vue?vue&type=template&id=eb3d2222&scoped=true"
import script from "./nodata.vue?vue&type=script&lang=js"
export * from "./nodata.vue?vue&type=script&lang=js"
import style0 from "./nodata.vue?vue&type=style&index=0&id=eb3d2222&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3d2222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb3d2222')) {
      api.createRecord('eb3d2222', component.options)
    } else {
      api.reload('eb3d2222', component.options)
    }
    module.hot.accept("./nodata.vue?vue&type=template&id=eb3d2222&scoped=true", function () {
      api.rerender('eb3d2222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NoData/nodata.vue"
export default component.exports